import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, useParams } from 'react-router-dom';
import { Icon } from 'front-onceforall-core';
import SidePanel from 'front-onceforall-core/dist/views/SidePanel';
import * as snackbarsActions from '../../actions/snackbars';
import ManageUserPermissions from './manageUserPermissions/ManageUserPermissions';
import ProjectOwnerTagEditionForm from './ProjectOwnerTagEditionForm';
import ProjectDetails from './projectDetails';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const ProjectView = props => {
  const [isManageUserPermissionsPanelOpen, setIsManageUserPermissionsPanelOpen] = React.useState(false);
  const [isProjectOwnerTagEditionFormPanelOpen, setIsProjectOwnerTagEditionFormPanelOpen] = React.useState(false);
  const params = useParams();
  const projectId = Number(params.projectId);
  let triggerClosePanel = () => {/* placeholder */};
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      to: "/projects",
      children: /*#__PURE__*/_jsxs("button", {
        className: "inline-container large link my-4",
        children: [/*#__PURE__*/_jsx(Icon, {
          icon: "arrow-left",
          color: "paragraph-light"
        }), /*#__PURE__*/_jsx(Translate, {
          value: "project.page.backToProjects"
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "col-12",
      children: /*#__PURE__*/_jsx(ProjectDetails, {
        history: props.history,
        actions: props.actions,
        organisation: props.organisation,
        projectId: projectId,
        onManageUserRolesPanelOpen: () => setIsManageUserPermissionsPanelOpen(true),
        openProjectOwnerTagEditionFormPanel: () => setIsProjectOwnerTagEditionFormPanelOpen(true)
      })
    }), isManageUserPermissionsPanelOpen && /*#__PURE__*/_jsx(SidePanel, {
      setCloseTrigger: closeFunction => {
        triggerClosePanel = closeFunction;
      },
      onClose: () => setIsManageUserPermissionsPanelOpen(false),
      children: /*#__PURE__*/_jsx(ManageUserPermissions, {
        actions: props.actions,
        organisationId: props.organisation.id,
        projectId: projectId,
        onClose: () => triggerClosePanel()
      })
    }), isProjectOwnerTagEditionFormPanelOpen && /*#__PURE__*/_jsx(SidePanel, {
      setCloseTrigger: closeFunction => {
        triggerClosePanel = closeFunction;
      },
      onClose: () => setIsProjectOwnerTagEditionFormPanelOpen(false),
      children: /*#__PURE__*/_jsx(ProjectOwnerTagEditionForm, {
        actions: props.actions,
        organisationId: props.organisation.id,
        projectId: projectId,
        onClose: () => triggerClosePanel()
      })
    })]
  });
};
ProjectView.propTypes = {
  history: PropTypes.object.isRequired,
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, snackbarsActions), dispatch)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ProjectView);